import { getPermissions, hasPermission } from "../../utilis/permissionStorage";

import React, { Component } from 'react';
import Paginations from '../GenericComponents/Pagination'
import ExportOptions from '../GenericComponents/ExportOptions'
import { Link } from 'react-router-dom';
import { delete_ApiManager, get_ApiManager, post_ApiManager, search_ApiManager, view_ApiManager } from '../ApiManager/ApiManager';
import * as FaIcons from 'react-icons/fa';
import swal from 'sweetalert'
import moment from 'moment';
import { Sorting } from '../GenericComponents/SortTables'
import { Modal } from 'react-bootstrap';
import { eduStatus, visaStatus } from '../../utilis/appStatus';
import { active_status } from '../../utilis/constants';
import ProviderStatCards from './ProviderStatCards';
import ProviderFiltersBar from './ProviderFiltersBar';
import ProviderAddEditModal from './ProviderAddEditModal';
import CourseAddEditModal from './CourseAddEditModal';
import CustomColumnsModel from '../GenericComponents/CustomColumnsModel';
import './viewProviders.css';
import TableEmptyRow, { visibleTableColumnCount } from '../GenericComponents/TableEmptyRow';
import ProviderDocumentsModal from './ProviderDocumentsModal';
import ClientDocumentsButton from '../reports/commissions/ClientDocumentsButton';
import { enrichProvidersWithDocuments } from './providerContractDocuments';

const EMPTY_FILTER_DRAFT = {
    name: '',
    campus: '',
    country: '',
    startDate: '',
    endDate: '',
    category: '',
    activeStatus: 'Active',
};

const providerFiltersEqual = (a, b) => (
    (a?.name || '').trim() === (b?.name || '').trim()
    && (a?.campus || '').trim() === (b?.campus || '').trim()
    && (a?.country || '').trim() === (b?.country || '').trim()
    && (a?.startDate || '') === (b?.startDate || '')
    && (a?.endDate || '') === (b?.endDate || '')
    && (a?.category || '') === (b?.category || '')
    && (a?.activeStatus || 'Active') === (b?.activeStatus || 'Active')
);

const hasAppliedProviderFilters = (filters) => Boolean(
    filters?.name?.trim()
    || filters?.campus?.trim()
    || filters?.country?.trim()
    || filters?.startDate
    || filters?.endDate
    || filters?.category
    || (filters?.activeStatus && filters.activeStatus !== 'Active'),
);


class ViewProviders extends Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
        var permissions = getPermissions();
        this.state = {
            name: '', category: '', campus:'', country:'', sDate:'', eDate:'',
            loading:false,
            initialLoading: true,
            tableReady: false,
            statsReady: false,
            allProviders:[],
            totalItem:'',
            currentPage: 1,
            lastPage:'',
            perPage: 10,
            open:false,
            order:'ASC',
            serach:'',
            perItem:'',
            search:'',
            allPermissions: permissions,
            activeStatus:1,
            showApplicantList: false,
            coursesApplicantList:[],
            packagesApplicantList:[],
            migCoursesApplicantList:[],
            bulk: false,
            bulkIds:[],
            categoriesList: [],
            showColumnsModal: false,
            providerModalMode: null,
            editProviderId: null,
            courseModalProvider: null,
            statsLoading: true,
            providerStats: {
                totalProviders: 0,
                activeProviders: 0,
                totalApplications: 0,
            },
            filterDraft: { ...EMPTY_FILTER_DRAFT },
            appliedFilters: { ...EMPTY_FILTER_DRAFT },
            providerDocumentsModal: null,
            headers: [
                {title: '#' , dataKey: "index", align: "text-center", key: 1, checked: true, canChange: false },
                {title: 'Provider' , dataKey: "providername", align:"text-center", key: 2, checked: true, canChange: false},
                {title: 'Category', dataKey: "categoryname", align: "text-center", key: 3, checked: true, canChange: true},
                {title: 'Campus' , dataKey: "city", align: "text-center", key: 4, checked: true, canChange: true},
                {title: 'Country', dataKey: "coutry", align: "text-center", key: 5, checked: false, canChange: true},
                {title: 'StartDate', dataKey: 'agreementstartdate', align:"text-center", key: 6, checked: true, canChange: true},
                {title: 'EndDate', dataKey: 'agreementenddate', align:"text-center", key: 7, checked: true, canChange: true},
                {title: 'Applicants', dataKey: 'applicant', align:"text-center", key: 8, checked: true, canChange: true},
                {title: 'Documents', dataKey: 'documents', align:"text-center", key: 13, checked: true, canChange: true},
                {title: 'Status', dataKey: 'active_status', align:"text-center", key: 12, checked: true, canChange: true},
                {title: 'Add Course', dataKey: '', key: 9, checked: true, canChange: false},
                {title: 'CreatedAt', dataKey: 'created_at', align: "text-center", key: 10, checked: false, canChange: true},
                {title: 'Actions', dataKey: '', key: 11, checked: true, canChange: false}
            ],
            migApplicantHeaders:[
                {title: '#', align: "text-center", dataKey: "", key:1},
                {title: 'Client Name', align: "text-center", dataKey: "clientname", key:2},
                {title: 'Category' , dataKey: "category",align:"text-center", key:3},
                {title: 'Course Name', dataKey: 'coursename', align:"text-center", key:4},
                {title: 'Status', dataKey: 'statusid', align:"text-center", key:5},
            ],
            eduApplicantHeaders:[
                {title: '#', align: "text-center", dataKey: "", key:1},
                {title: 'Client Name', align: "text-center", dataKey: "clientname", key:2},
                {title: 'Category' , dataKey: "category",align:"text-center", key:3},
                {title: 'Course Name', dataKey: 'coursename', align:"text-center", key:4},
                {title: 'Status', dataKey: 'statusid', align:"text-center", key:5},
            ],
            packageApplicantHeaders:[
                {title: '#', align: "text-center", dataKey: "", key:1},
                {title: 'Client Name', align: "text-center", dataKey: "clientname", key:2},
                {title: 'Category' , dataKey: "category",align:"text-center", key:3},
                {title: 'Package Name', dataKey: 'packagename', align:"text-center", key:4},
                {title: 'Status', dataKey: 'statusid', align:"text-center", key:5},
            ],
        }
    }
    checkInitialLoadComplete = () => {
        if (!this.isInitialLoad) {
            return;
        }
        const { tableReady, statsReady } = this.state;
        if (tableReady && statsReady) {
            this.isInitialLoad = false;
            this.setState({ initialLoading: false });
        }
    }
    componentDidMount() {
        this.isInitialLoad = true;
        if(this.state.allPermissions['providers'] === 1){
            this.getProviders();
            this.getCategories();
            this.fetchProviderStats();
        }
    }
        // Fetch provider categories for the search dropdown
    getCategories() {
        let url = 'provider-categories';
        get_ApiManager('', url,(res) => {
            console.log('Provider Categories', res);
            const list = Array.isArray(res.data?.data) ? res.data.data : [];
            const options = list
                .filter((item) => item?.active_status !== false && item?.active_status !== 0)
                .map((item) => ({ id: item.id, title: item.name }));
            this.setState({ categoriesList: options });
        },(err) => {
            console.log(err);
        });
    }
    fetchProviderStats() {
        this.setState({ statsLoading: true });

        get_ApiManager('', 'getProvidersList', (listRes) => {
            const allList = Array.isArray(listRes?.data?.data) ? listRes.data.data : [];
            const totalProviders = allList.length;

            view_ApiManager('providers', 1, 1, (activeRes) => {
                const activeProviders = Number(activeRes?.data?.data?.total) || 0;

                this.setState((prev) => ({
                    providerStats: {
                        ...prev.providerStats,
                        totalProviders,
                        activeProviders,
                    },
                }));

                this.fetchApplicantStats(activeProviders);
            }, () => {
                this.setState((prev) => ({
                    providerStats: {
                        ...prev.providerStats,
                        totalProviders,
                    },
                    statsLoading: false,
                    statsReady: true,
                }), this.checkInitialLoadComplete);
            });
        }, () => {
            view_ApiManager('providers', 1, 1, (activeRes) => {
                const activeProviders = Number(activeRes?.data?.data?.total) || 0;

                this.setState((prev) => ({
                    providerStats: {
                        ...prev.providerStats,
                        totalProviders: activeProviders,
                        activeProviders,
                    },
                }));

                this.fetchApplicantStats(activeProviders);
            }, () => {
                this.setState({
                    statsLoading: false,
                    statsReady: true,
                }, this.checkInitialLoadComplete);
            });
        });
    }
    fetchApplicantStats(providerCount) {
        if (!providerCount) {
            this.setState((prev) => ({
                providerStats: {
                    ...prev.providerStats,
                    totalApplications: 0,
                },
                statsLoading: false,
                statsReady: true,
            }), this.checkInitialLoadComplete);
            return;
        }

        const perPage = 100;
        const totalPages = Math.ceil(providerCount / perPage);
        let page = 1;
        let allProviders = [];

        const fetchPage = () => {
            view_ApiManager('providers', page, perPage, (res) => {
                const list = res?.data?.data?.data || [];
                allProviders = allProviders.concat(list);

                if (page < totalPages) {
                    page += 1;
                    fetchPage();
                    return;
                }

                const totalApplications = allProviders.reduce(
                    (sum, provider) => sum + (Number(provider.applicant) || 0),
                    0,
                );

                this.setState((prev) => ({
                    providerStats: {
                        ...prev.providerStats,
                        totalApplications,
                    },
                    statsLoading: false,
                    statsReady: true,
                }), this.checkInitialLoadComplete);
            }, () => {
                this.setState({
                    statsLoading: false,
                    statsReady: true,
                }, this.checkInitialLoadComplete);
            });
        };

        fetchPage();
    }

    openProviderDocumentsModal = (provider) => {
        if (!provider?.id) {
            return;
        }
        this.setState({
            providerDocumentsModal: {
                id: provider.id,
                name: provider.providername || 'Provider',
                documents: Array.isArray(provider.documents) ? provider.documents : [],
            },
        });
    }

    closeProviderDocumentsModal = () => {
        this.setState({ providerDocumentsModal: null });
    }

    handleProviderDocumentsUpdated = (providerId, documents) => {
        if (!providerId) {
            return;
        }
        const safeDocuments = Array.isArray(documents) ? documents : [];
        this.setState((prev) => ({
            allProviders: prev.allProviders.map((provider) => (
                provider.id === providerId
                    ? { ...provider, documents: safeDocuments }
                    : provider
            )),
            providerDocumentsModal: prev.providerDocumentsModal?.id === providerId
                ? { ...prev.providerDocumentsModal, documents: safeDocuments }
                : prev.providerDocumentsModal,
        }));
    }

    async getProviders() {
        this.setState({loading: true});
        let currentPage = this.state.currentPage;
        let perPage = this.state.perPage;
        let url = 'providers';
        view_ApiManager(url, currentPage, perPage,(res) => {
            console.log('All providers',res);
            const rawProviders = res.data.data['data'];
            enrichProvidersWithDocuments(rawProviders)
                .then((providers) => {
                    this.setState({
                        allProviders: providers,
                        loading: false,
                        tableReady: true,
                        totalItem: res.data.data['total'],
                        perPage: res.data.data['per_page'],
                        lastPage: res.data.data['last_page'],
                        perItem: providers.length,
                    }, () => {
                        this.checkInitialLoadComplete();
                    });
                })
                .catch(() => {
                    const providers = rawProviders.map((provider) => ({
                        ...provider,
                        documents: [],
                    }));
                    this.setState({
                        allProviders: providers,
                        loading: false,
                        tableReady: true,
                        totalItem: res.data.data['total'],
                        perPage: res.data.data['per_page'],
                        lastPage: res.data.data['last_page'],
                        perItem: providers.length,
                    }, () => {
                        this.checkInitialLoadComplete();
                    });
                });
        },(err) => {
            console.log(err);
            this.setState({
                loading: false,
                tableReady: true,
            }, this.checkInitialLoadComplete);
        });
    }
        // CallBack function handle pagination
    handlePaginationCallback = (i, perPage) =>{
        window.scrollTo(0, 0);
        if(!this.state.search){
            if(perPage && perPage != ''){
                this.setState({ perPage : perPage, currentPage:1}, () => {  this.getProviders();  }); 
            } else {this.setState({ currentPage : i}, () => { this.getProviders(); }); }
        } else{
            if(perPage && perPage != ''){
                this.setState({ perPage : perPage,currentPage:1}, () => {  this.handleSearchCallback(this.state.search);  }); 
            } else {this.setState({ currentPage : i}, () => { this.handleSearchCallback(this.state.search); }); }
        }
    }
        //Delete a provider
    async handleDelete(delete_id, name) {
        swal({
            title: "Are you sure?",
            text: "You will not be able to recover ("+ name +")",icon: "warning", buttons: true, dangerMode: true,
          }).then((willDelete) => {
            if (willDelete) {
            const data = delete_id;
            let url = 'providers';
            delete_ApiManager(data, url,(res) => {
                console.log('Provider Deleted',res);
                swal("Provider ("+ name +") "+" deleted successfully", {icon: "success" });
                this.getProviders();
                this.fetchProviderStats();
             },(err) => {
                 console.log(err);
                }); 
            }   
        });
     }
       // Table sorting
     sorting = (col) => {
        const sortResult = Sorting(this.state.allProviders, col, this.state.order)
        this.setState({order: sortResult[0], allProviders: sortResult[1]})
     }
     //Search Api
     handleSearchCallback = (input1, input2, input3, input4, input5, input6, input7) => {
        let Name, Campus, Category, Country, StartDate, EndDate, ActiveStatus;
        if(input1 === 'clear'){
            this.setState({
                name: '', category: '', campus:'', country:'', sDate:'', eDate:'', activeStatus: 1,
                search: '', currentPage: 1,
                filterDraft: { ...EMPTY_FILTER_DRAFT },
                appliedFilters: { ...EMPTY_FILTER_DRAFT },
            }, () => this.getProviders());
            return;
        } else if (input1 === 'yes') {
            Name = this.state.name;
            Campus = this.state.campus;
            Category = this.state.category;
            Country= this.state.country;
            StartDate = this.state.sDate;
            EndDate = this.state.eDate;
            ActiveStatus = this.state.activeStatus;
          } else {
            Name = input1;
            Campus = input2;
            // input6 is the selected category title; convert it to its DB id for the backend
            const matchedCategory = this.state.categoriesList.find((c) => c.title === input6);
            Category = matchedCategory ? matchedCategory.id : (input6 || '');
            Country= input3;
            StartDate = input4;
            EndDate = input5;
            ActiveStatus = input7 === 'Active' ? 1 : input7 === 'Inactive' ? 0 : !input7 ? this.state.activeStatus : 2;
            this.setState({search:'yes', name:Name, campus: Campus, category: Category, country: Country, sDate: StartDate, eDate: EndDate, activeStatus: ActiveStatus});
        }
        const data = {
            name:Name,
            campus:Campus,
            category:Category,
            country:Country,
            startdate: StartDate,
            enddate: EndDate,
            activeStatus: ActiveStatus,
        }
        console.log(data);

        let currentPage = this.state.currentPage;
        let perPage = this.state.perPage;
        let url = `search/providers`;
        this.setState({ loading: true });
        search_ApiManager(url, data, currentPage, perPage,(res) => {
            console.log('search result',res);
            const rawProviders = res.data.data['data'];
            enrichProvidersWithDocuments(rawProviders)
                .then((providers) => {
                    this.setState({
                        allProviders: providers,
                        totalItem: res.data.data['total'],
                        perPage: res.data.data['per_page'],
                        lastPage: res.data.data['last_page'],
                        perItem: providers.length,
                        loading: false,
                    });
                })
                .catch(() => {
                    this.setState({
                        allProviders: rawProviders.map((provider) => ({
                            ...provider,
                            documents: [],
                        })),
                        totalItem: res.data.data['total'],
                        perPage: res.data.data['per_page'],
                        lastPage: res.data.data['last_page'],
                        perItem: rawProviders.length,
                        loading: false,
                    });
                });
        },(err) => {
            console.log(err);
            this.setState({ loading: false });
        });
    }
    handleColumnsCallback = (selectedColumns) => {
        this.setState({headers: selectedColumns})
     }

    handleColumnsModalCallback = (action, selectedColumns) => {
        if (action === 'add') {
            this.handleColumnsCallback(selectedColumns);
        }
        this.setState({ showColumnsModal: false });
    }

    openAddProviderModal = () => {
        this.setState({ providerModalMode: 'add', editProviderId: null });
    }

    openEditProviderModal = (providerId) => {
        this.setState({ providerModalMode: 'edit', editProviderId: providerId });
    }

    closeProviderModal = () => {
        this.setState({ providerModalMode: null, editProviderId: null });
    }

    handleProviderModalSuccess = () => {
        this.closeProviderModal();
        this.getProviders();
        this.fetchProviderStats();
    }

    openAddCourseModal = (provider) => {
        this.setState({
            courseModalProvider: {
                id: provider.id,
                name: provider.providername,
                category: provider.categoryname,
                country: provider.country ? provider.country : 'null',
            },
        });
    }

    closeCourseModal = () => {
        this.setState({ courseModalProvider: null });
    }

    handleCourseModalSuccess = () => {
        this.closeCourseModal();
        this.getProviders();
        this.fetchProviderStats();
    }

    handleFilterDraftChange = (filterDraft) => {
        this.setState({ filterDraft });
    }

    handleApplyFilters = () => {
        const { filterDraft } = this.state;
        this.setState({
            currentPage: 1,
            appliedFilters: { ...filterDraft },
        }, () => {
            this.handleSearchCallback(
                filterDraft.name,
                filterDraft.campus,
                filterDraft.country,
                filterDraft.startDate,
                filterDraft.endDate,
                filterDraft.category,
                filterDraft.activeStatus,
            );
        });
    }

    handleResetFilters = () => {
        const { appliedFilters, filterDraft, search } = this.state;
        const hasPendingChanges = !providerFiltersEqual(filterDraft, appliedFilters);
        const hasActiveSearch = search === 'yes' || hasAppliedProviderFilters(appliedFilters);

        if (!hasPendingChanges && !hasActiveSearch) {
            return;
        }

        if (!hasActiveSearch) {
            this.setState({ filterDraft: { ...appliedFilters } });
            return;
        }

        this.setState({
            filterDraft: { ...EMPTY_FILTER_DRAFT },
            appliedFilters: { ...EMPTY_FILTER_DRAFT },
            currentPage: 1,
        }, () => {
            this.handleSearchCallback('clear');
        });
    }

    clearBulkSelection = () => {
        const newState = this.state.allProviders.map((obj) => ({ ...obj, checked: false }));
        this.setState({ bulk: false, bulkIds: [], allProviders: newState });
    }

    handleSelectAllChange = (checked) => {
        if (checked) {
            this.allBulk();
        } else {
            this.clearBulkSelection();
        }
    }

    applicantList = (courseid) => {
        let url = `allApplicantList/${courseid}`;
        console.log(url);
        get_ApiManager('', url,(res) => {
            console.log('applicant-list',res);
            this.setState({
                coursesApplicantList: res.data.data['courses'],
                migCoursesApplicantList: res.data.data['migcourses'],
                packagesApplicantList: res.data.data['packages'],
                showApplicantList:true})
        },(err) => {
            console.log(err);
        })
    }
     // Table sorting
    courseSorting = (col) => {
        const sortResult = Sorting(this.state.coursesApplicantList, col, this.state.order)
        this.setState({order: sortResult[0], coursesApplicantList: sortResult[1]})
    }
    courseMigModalSorting = (col) => {
        const sortResult = Sorting(this.state.migCoursesApplicantList, col, this.state.order)
        this.setState({order: sortResult[0], migCoursesApplicantList: sortResult[1]}) 
    }
     // Table sorting
    packageSorting = (col) => {
        const sortResult = Sorting(this.state.packageApplicantList, col, this.state.order)
        this.setState({order: sortResult[0], packageApplicantList: sortResult[1]})
    }
     // All Bulk
    allBulk = () => {
    const newState = this.state.allProviders.map(obj => {
            return {...obj, checked: true};
    });
    const array = [];
    this.state.allProviders.map(x => {
        array.push({ id: x.id});
    })
    this.setState({allProviders: newState, bulk: true, bulkIds: array});
    }
     // Select Bulk
    selectBulk = () => {
    const newState = this.state.allProviders.map(obj => {
        return {...obj, checked: false};
    });
    this.setState({bulk: !this.state.bulk, bulkIds: [],allProviders: newState});
    }
    onBulkClick = (id, name, checked) => {
        console.log(id, checked)
        if(checked == true){
            const newState = this.state.allProviders.map(obj => {
                if (obj.id == id) {
                  return {...obj, checked: true};
                }
                return obj;
            });
            this.setState({bulkIds: [...this.state.bulkIds, { id:id, name:name}], allProviders: newState, bulk: true});
        } else{
            const newState = this.state.allProviders.map(obj => {
                if (obj.id == id) {
                  return {...obj, checked: false};
                }
                return obj;
            });
            var array = this.state.bulkIds.filter(function(item) {return item.id !== id});
            this.setState({bulkIds: array, allProviders: newState})
        }
     }
     onBulkDelete = () => {
        swal({
            title: "Are you sure?",
            text: "You will not be able to recover these providers",icon: "warning", buttons: true, dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                let url = 'bulkDeleteProvider';
                const data = {
                    bulkList: this.state.bulkIds,
                }
                console.log(data);
                post_ApiManager(data, url,(res) => {
                    console.log('deleted',res);
                    if(res.data.error) swal(" ", res.data.error, "error")
                    else {
                        swal("Providers has been deleted successfully!", {icon: "success" });
                        this.getProviders();
                        this.fetchProviderStats();
                        this.setState({bulk: false, bulkIds:[]})
                        // this.handleNotification();
                    };   
                },(err) => {
                    console.log(err);
                });
            }
        }); 
     }

    renderTableSkeletonRows(headers) {
        const rowCount = Math.min(Number(this.state.perPage) || 10, 8);
        return Array.from({ length: rowCount }, (_, rowIndex) => (
            <tr key={`providers-skeleton-${rowIndex}`} className="cms-providers-table-skeleton-row" aria-hidden="true">
                <td className="text-center cms-providers-checkbox-col">
                    <span className="cms-providers-skeleton-bone cms-providers-skeleton-bone--checkbox" />
                </td>
                {headers.map((head) => (
                    head.checked && (
                        <td key={head.key} className={head.align || ''}>
                            <span className={`cms-providers-skeleton-bone${
                                head.key === 9 || head.key === 11
                                    ? ' cms-providers-skeleton-bone--short'
                                    : head.key === 8 || head.key === 13
                                        ? ' cms-providers-skeleton-bone--badge'
                                        : ''
                            }`} />
                        </td>
                    )
                ))}
            </tr>
        ));
    }

    renderApplicantSection(title, headers, rows, onSort, categoryLabel, nameKey, statusOptions, sectionVariant) {
        return (
            <div className={`cms-applicant-modal-section cms-applicant-modal-section--${sectionVariant}`}>
                <h3 className="cms-applicant-modal-section-title">{title}</h3>
                <div className="cms-applicant-modal-table-wrap">
                    <table className="cms-applicant-modal-table">
                        <thead>
                            <tr>
                                {headers.map((head) => (
                                    <th
                                        id={head.dataKey || head.keyData}
                                        key={head.key}
                                        className={head.align}
                                        onClick={() => onSort(head.dataKey)}
                                    >
                                        {head.title}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {rows.length === 0 ? (
                                <tr>
                                    <td colSpan={headers.length} className="cms-applicant-modal-empty">
                                        No {title.toLowerCase()} applicants found
                                    </td>
                                </tr>
                            ) : rows.map((row, index) => (
                                <tr key={row.appid || `${row.clientid}-${index}`}>
                                    <td className="text-center">{index + 1}</td>
                                    <td className="text-center">
                                        <Link
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="cms-applicant-modal-link"
                                            to={`/clients/view-client-detail/${row.clientid}`}
                                        >
                                            {row.clientname}
                                        </Link>
                                    </td>
                                    <td className="text-center">{categoryLabel}</td>
                                    <td className="text-center">{row[nameKey]}</td>
                                    <td className="text-center">
                                        {statusOptions
                                            .filter((status) => status.value == row.statusid)
                                            .map((status) => status.title)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

  render(){
    const role = JSON.parse(localStorage.getItem('user_role'));
    let count = this.state.currentPage * this.state.perPage - this.state.perPage +1;
    const headers = this.state.headers;
    const showingFrom = this.state.totalItem > 0 ? count : 0;
    const showingTo = this.state.totalItem > 0
      ? Math.min(count + this.state.perItem - 1, this.state.totalItem)
      : 0;
    const allRowsSelected = this.state.allProviders.length > 0
      && this.state.allProviders.every((provider) => provider.checked);
    const canApplyFilters = hasAppliedProviderFilters(this.state.filterDraft);
    const canResetFilters = this.state.search === 'yes'
      || hasAppliedProviderFilters(this.state.appliedFilters)
      || !providerFiltersEqual(this.state.filterDraft, this.state.appliedFilters);

      return(
        <div className="cms-providers-page">
         {this.state.allPermissions['providers'] === 1 ?
         <>
         <div className="cms-providers-page-header">
           <div className="cms-providers-page-header-text">
             <h1 className="cms-providers-page-title">Providers</h1>
             <p className="cms-providers-page-subtitle">
               Manage all education and migration service providers
             </p>
           </div>
           <button
             type="button"
             className="cms-providers-add-btn"
             onClick={this.openAddProviderModal}
           >
             <FaIcons.FaPlus size={11} />
             Add Provider
           </button>
         </div>

         <ProviderStatCards
           stats={this.state.providerStats}
           loading={this.state.initialLoading || this.state.statsLoading}
         />

         <ProviderFiltersBar
           draft={this.state.filterDraft}
           onDraftChange={this.handleFilterDraftChange}
           onApply={this.handleApplyFilters}
           onReset={this.handleResetFilters}
           canApply={canApplyFilters}
           canReset={canResetFilters}
           categoriesList={this.state.categoriesList}
           activeStatusOptions={active_status}
           headers={headers}
         />

         <div className="cms-providers-table-card">
           <div className="cms-providers-table-toolbar">
             <p className="cms-providers-table-toolbar-text">
               {this.state.totalItem > 0
                 ? `Showing ${showingFrom} to ${showingTo} of ${this.state.totalItem} providers`
                 : '\u00a0'}
             </p>
             <div className="cms-providers-table-toolbar-actions">
               {role === 2 && this.state.bulk && this.state.bulkIds[0] && (
                 <button
                   type="button"
                   className="cms-providers-toolbar-delete-btn"
                   onClick={() => this.onBulkDelete()}
                 >
                   <FaIcons.FaTrashAlt size={11} />
                   Delete Selected ({this.state.bulkIds.length})
                 </button>
               )}
               <div className="cms-providers-table-toolbar-tools">
                 <button
                   type="button"
                   className="cms-providers-columns-btn"
                   onClick={() => this.setState({ showColumnsModal: true })}
                   title="Customize columns"
                 >
                   <FaIcons.FaCog size={12} />
                   Columns
                 </button>
                 {role === 2 && (
                   <div className="cms-providers-export-actions">
                     <ExportOptions
                       pdffilename={'providers.pdf'}
                       csvfilename={'providers.csv'}
                       header="Providers List"
                       xlsxfilename={'providers'}
                       columns={this.state.headers}
                       data={this.state.allProviders}
                       premium
                     />
                   </div>
                 )}
               </div>
             </div>
           </div>

           <div className="cms-providers-table-scroll">
         <table id="viewproviders" className="cms-providers-table">
         <thead>
         <tr>
         <th className="text-center cms-providers-checkbox-col">
           <input
             type="checkbox"
             checked={allRowsSelected}
             onChange={(e) => this.handleSelectAllChange(e.target.checked)}
             aria-label="Select all providers"
           />
         </th>
         {headers.map(head => (
         head.checked &&
         <th id={head.dataKey} className={head.align} onClick={() => head.dataKey && this.sorting(head.dataKey)} key={head.key}>
         {head.title}</th>
         ))}
         </tr>
         </thead>
         <tbody>
         {this.state.initialLoading || this.state.loading
           ? this.renderTableSkeletonRows(headers)
           : this.state.allProviders.length === 0
           ? (
             <TableEmptyRow
               colSpan={visibleTableColumnCount(headers, 1)}
               message="No providers found"
               className="px-3 py-10 text-center text-sm font-medium text-slate-500"
             />
           )
           : this.state.allProviders.map((value, index) => {
         const rowNum = count + index;
         return (
         <tr key={value.id}>
         <td className="text-center cms-providers-checkbox-col">
           <input
             type="checkbox"
             checked={!!value.checked}
             onChange={(e) => this.onBulkClick(value.id, value.name, e.target.checked)}
             aria-label={`Select ${value.providername}`}
           />
         </td>
         {headers[0]['checked'] && <td className="text-center">{rowNum}</td>}
         {headers[1]['checked'] && <td>
         <Link className="cms-providers-provider-name" to={`/providers/provider-details/${value.id}/`}>
           {value.providername}
         </Link>
         </td>}
         {headers[2]['checked'] && <td>{value.categoryname}</td>}
         {headers[3]['checked'] && <td className="cms-providers-campus-cell">{value.city}</td>}
         {headers[4]['checked'] && <td>{value.country}</td>}
         {headers[5]['checked'] && <td className="text-center">{value.agreementstartdate ?  moment(value.agreementstartdate).format('D MMM YYYY')  : '--' }</td>}
         {headers[6]['checked'] && <td className="text-center">{value.agreementenddate ? moment(value.agreementenddate).format('D MMM YYYY'): '--'}</td>}
         {headers[7]['checked'] && <td className="text-center">
         <span className="cms-providers-applicant-link" onClick={() => this.applicantList(value.id)}>({value.applicant})</span>
         </td>}
         {headers[8]?.checked && (
           <td className="text-center">
             <ClientDocumentsButton
               documents={value.documents}
               clientName={value.providername || 'Provider'}
               onOpen={() => this.openProviderDocumentsModal(value)}
             />
           </td>
         )}
         {headers[9]?.checked && (
           <td className="text-center">
             <span className={`cms-providers-status-badge ${
               value.active_status == 1
                 ? 'cms-providers-status-badge--active'
                 : 'cms-providers-status-badge--inactive'
             }`}>
               <span className="cms-providers-status-dot" />
               {value.active_status == 1 ? 'Active' : 'Inactive'}
             </span>
           </td>
         )}
         {headers[10]['checked'] && <td className="text-center">
         <button
           type="button"
           className="cms-providers-action-btn"
           onClick={() => this.openAddCourseModal(value)}
         >
         {value.categoryname === 'Migration' ? 'Add Application' : 'Add Course'}
         </button>
         </td>}
         {headers[12]['checked'] && <td className="text-center">
         <div className="cms-providers-row-actions">
         {this.state.allPermissions['can_edit_provider'] === 1 && (
           <button
             type="button"
             onClick={() => this.openEditProviderModal(value.id)}
             className="cms-providers-table-icon cms-providers-table-icon--edit"
             title="Edit"
           >
             <FaIcons.FaRegEdit size={11} />
           </button>
         )}
         <button
           type="button"
           onClick={() => this.handleDelete(value.id, value.providername)}
           className="cms-providers-table-icon cms-providers-table-icon--delete"
           title="Delete"
         >
           <FaIcons.FaTrashAlt size={11} />
         </button>
         </div>
         </td>}
         {headers[11]['checked'] && <td className="text-center"><small>{moment(value.created_at).format('D MMM YYYY')}</small></td>}
         </tr>
         );
         })}
         </tbody>
         </table>
         </div>
         </div>

         <div className="cms-providers-footer">
         <Paginations
         currentPage= {this.state.currentPage}
         total= {this.state.totalItem} 
         itemsPerPage= {this.state.perPage}
         lastPage={this.state.lastPage}
         totalItems={this.state.totalItem}
         perItem={this.state.perItem}
         onPageChange= {this.handlePaginationCallback} 
         />
         </div>

         </>: <div className="cms-providers-no-access">You dont have permission to access this pages!</div>}
         <Modal
           size="lg"
           show={this.state.showApplicantList}
           aria-labelledby="cms-applicant-modal-title"
           centered
           onHide={() => this.setState({ showApplicantList: false })}
           backdropClassName="cms-applicant-modal-backdrop"
           dialogClassName="cms-applicant-modal-dialog"
           contentClassName="cms-applicant-modal-content"
           className="cms-applicant-modal"
         >
        <Modal.Header closeButton className="cms-applicant-modal-header">
          <Modal.Title id="cms-applicant-modal-title" className="cms-applicant-modal-title">
            Applicant List
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="cms-applicant-modal-body">
          {this.renderApplicantSection(
            'Courses',
            this.state.eduApplicantHeaders,
            this.state.coursesApplicantList,
            this.courseSorting,
            'Education',
            'coursename',
            eduStatus,
            'courses',
          )}
          {this.renderApplicantSection(
            'Migration',
            this.state.migApplicantHeaders,
            this.state.migCoursesApplicantList,
            this.courseMigModalSorting,
            'Migration',
            'coursename',
            visaStatus,
            'migration',
          )}
          {this.renderApplicantSection(
            'Packages',
            this.state.packageApplicantHeaders,
            this.state.packagesApplicantList,
            this.packageSorting,
            'Education',
            'packagename',
            eduStatus,
            'packages',
          )}
        </Modal.Body>
        <Modal.Footer className="cms-applicant-modal-footer">
          <button
            type="button"
            className="cms-applicant-modal-btn-close"
            onClick={() => this.setState({ showApplicantList: false })}
          >
            Close
          </button>
        </Modal.Footer>
        </Modal>
        <CustomColumnsModel
          show={this.state.showColumnsModal}
          parentCallback={this.handleColumnsModalCallback}
          allcolumns={headers}
        />
        <ProviderAddEditModal
          show={Boolean(this.state.providerModalMode)}
          mode={this.state.providerModalMode}
          providerId={this.state.editProviderId}
          onClose={this.closeProviderModal}
          onSuccess={this.handleProviderModalSuccess}
        />
        <CourseAddEditModal
          show={Boolean(this.state.courseModalProvider)}
          mode="add"
          provider={this.state.courseModalProvider}
          onClose={this.closeCourseModal}
          onSuccess={this.handleCourseModalSuccess}
        />
        <ProviderDocumentsModal
          open={Boolean(this.state.providerDocumentsModal)}
          providerId={this.state.providerDocumentsModal?.id}
          providerName={this.state.providerDocumentsModal?.name}
          documents={this.state.providerDocumentsModal?.documents}
          onClose={this.closeProviderDocumentsModal}
          onDocumentsUpdated={this.handleProviderDocumentsUpdated}
        />
        </div>
      )
  }
}
export default ViewProviders